import { DateFormatEnum, isValidDate } from "@core/utils";
import { ValidationInputType } from "@generation/core";
import { AbstractValidation } from "./AbstractValidation";
import { CustomErrorMessage } from "./ValidationHelper";
import { translate } from "../Locales/translator";

export class DateValidation extends AbstractValidation {
  key = "isValidDate";
  constructor(private readonly required = true, customErrorMessage?: CustomErrorMessage) {
    super(customErrorMessage);
  }

  validate = (value: ValidationInputType) => {
    if (!this.required && (value === "" || value === undefined || value === null)) {
      return true;
    }

    const isValidDateRegex =
      typeof value === "string" &&
      /^(0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.](19|20)\d\d$/.test(value);

    if (isValidDateRegex) {
      try {
        return isValidDate(value, DateFormatEnum.Date);
      } catch {
        return false;
      }
    }
    return false;
  };

  defaultMessage = (label: string): string => translate("Generation_Form_{label}MoetEenDatumZijn", { label: label });
}
